<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            fluid
            fill-height
    >
        <!--        <v-layout-->
        <!--                tag="v-list"-->
        <!--                column-->
        <!--                fill-height-->
        <!--        >-->
        <!--            asd-->
        <!--        </v-layout>-->
        <v-layout
                justify-center
                align-center

        >
            <v-flex
                    class="xs4"
            >
                <span style="font-size: 30px; font-weight: bold">Center1</span><br/><br/>
                <span style="font-size: 20px; font-weight: bold">VIP 발렛 예약 관리 페이지</span><br/><br/>

                <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                >
                    <!--                    <v-text-field-->
                    <!--                            v-model="firstname"-->
                    <!--                            :rules="nameRules"-->
                    <!--                            :counter="10"-->
                    <!--                            label="First name"-->
                    <!--                            required-->
                    <!--                    ></v-text-field>-->
                    <v-text-field
                            color="black"
                            label="Id"
                            v-model="sign_id"
                            :rules="nameRules"
                            required
                    />
                    <v-text-field
                            color="black"
                            :type="'password'"
                            label="Password"
                            :rules="nameRules"
                            v-model="sign_password"
                            required
                    />
                    <!-- TODO 로컬 변수? cognito attribute? -->
                    <v-text-field
                            color="black"
                            label="Name"
                            :rules="nameRules"
                            v-model="sign_name"
                            required
                    />
                    <v-btn
                            :disabled="!valid"
                            color="success"
                            @click="validate()"
                    >로그인
                    </v-btn>
                    <!--                    <v-btn-->
                    <!--                            :disabled="!valid"-->
                    <!--                            color="success"-->
                    <!--                            @click="validate"-->
                    <!--                    >-->
                    <!--                        Validate-->
                    <!--                    </v-btn>-->
                </v-form>
            </v-flex>
        </v-layout>
        <v-dialog v-model="edit_dialog" persistent max-width="600px">
            <v-card>
                <v-card-text>
                    <span style="font-weight: bold; font-size: 17px;" >비밀번호 변경</span>
                    <v-container grid-list-md>
                        <v-form ref="edit_form"
                                v-model="edit_valid"
                                lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field label="새 비밀번호"
                                                  :type="'password'"
                                                  v-model="edit_item.NewPassword"
                                                  :rules="edit_password_rules"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="edit_dialog = false">취소</v-btn>
                    <v-btn color="blue darken-1" flat @click="edit_submit()">변경하기</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {Auth,} from 'aws-amplify'
    import tool_app from '../utils/tool_app'

    function lg (...args) { tool_app.lg('Sign] ', ...args); }

    let comp = null;
    export default {
        components: {},
        data () {
            return {
                valid: true,
                sign_id: '',
                sign_password: '',
                sign_name: '',
                nameRules: [
                    // v => !!v || 'Name is required',
                    v => v.length >= 2 || '2자 이상 입력해주세요..'
                ],
                // email: '',
                // emailRules: [
                //   v => !!v || 'E-mail is required',
                //   v => /.+@.+/.test(v) || 'E-mail must be valid'
                // ],
                // client: null,
                // // sign_id: 'test1233',
                // sign_password: 'test1233',
                // sign_name: '이름',
                dialog: false,

                edit_dialog: false,
                edit_valid: false,
                edit_user: {},
                edit_item: {},
                edit_password_rules: [
                    v => !!(v)  || '입력해주세요..',
                    v => !!(v && v.length >= 6) || '6자 이상 입력해주세요',
                ],
            };
        },
        created: function () {
            comp = this;
            lg('created 2222 ',tool_app.isDebug);
            if(tool_app.isDebug) {
                comp.sign_id = 'test333';
                comp.sign_password = '123123123';
                comp.sign_name = '김영만';
            }
        },
        beforeDestroy: function () {
            lg('beforeDestroy 1');
        },
        methods: {
            // complete (index) {
            //   this.list[index] = !this.list[index];
            // },
            validate () {
                lg('validate 1');
                if (comp.$refs.form.validate()) {
                    lg('validate 2');
                    comp.signin();
                }
            },
            newpassword_click() {
                lg('newpassword_click 1');
            },
            async signin () {
                lg('signin 1');
                try {
                    let user = await Auth.signIn(comp.sign_id, comp.sign_password);
                    if (user.challengeName === 'SMS_MFA' ||
                        user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                        // // You need to get the code from the UI inputs
                        // // and then trigger the following function with a button click
                        // const code = getCodeFromUserInput();
                        // // If MFA is enabled, sign-in should be confirmed with the confirmation code
                        // const loggedUser = await Auth.confirmSignIn(
                        //     user,   // Return object from Auth.signIn()
                        //     code,   // Confirmation code
                        //     mfaType // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
                        // );
                        return;
                    } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        // const {requiredAttributes} = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
                        // // You need to get the new password and required attributes from the UI inputs
                        // // and then trigger the following function with a button click
                        // // For example, the email and phone_number are required attributes
                        // let dialog = await comp.$dialog
                        //     .prompt({
                        //         // title: "새 비밀번호를 입력해주세요.",
                        //         // body: "새 비밀번호를 입력해주세요.",
                        //         // promptHelp: '새 비밀번호를 입력해주세요. "[+:okText]"'
                        //         promptHelp: "새 비밀번호를 입력해주세요. \"[+:okText]\"",
                        //         okText: '비밀번호 변경',
                        //
                        //     });
                        //     // .then(async dialog => {
                        //     //     // Triggered when proceed button is clicked
                        //     //     // Show an alert with the user's input as the message
                        //     //     // this.$dialog.alert(dialog.data || '[empty]');
                        //         let newPassword = dialog.data;
                        //         const loggedUser = await Auth.completeNewPassword(
                        //             user,              // the Cognito User Object
                        //             newPassword,       // the new password
                        //             // // OPTIONAL, the required attributes
                        //             // {
                        //             //     email,
                        //             //     phone_number,
                        //             // }
                        //         );
                        //     // })
                        //     // .catch(() => {
                        //     //     // Triggered when dialog is dismissed by user
                        //     //
                        //     //     console.log('Prompt dismissed');
                        //     // });
                        // // const {username, email, phone_number} = getInfoFromUserInput();

                        // comp.$dialog
                        //     .prompt({
                        //         title: "새 비밀번호를 입력해주세요.",
                        //         // body: "What is the most important thing in life?",
                        //         // promptHelp: '새 비밀번호 "[+:okText]"'
                        //     })
                        //     .then(async dialog => {
                        //         lg('asd ', dialog);
                        //             let newPassword = dialog;
                        //             const loggedUser = await Auth.completeNewPassword(
                        //                 user,              // the Cognito User Object
                        //                 newPassword,       // the new password
                        //             );
                        //     })
                        //     .catch(() => {
                        //         lg('Prompt dismissed');
                        //     });

                        comp.edit_dialog = true;
                        comp.edit_user = user;
                        comp.edit_item = {};
                    } else if (user.challengeName === 'MFA_SETUP') {
                        // // This happens when the MFA method is TOTP
                        // // The user needs to setup the TOTP before using it
                        // // More info please check the Enabling MFA part
                        // Auth.setupTOTP(user);
                        return;
                    } else {
                        // The user directly signs in
                        lg(user);
                    }
                    comp.$cookies.set('accountname', this.sign_name);
                }
                catch (err) {
                    lg('signin 3 err:', err);
                    if(err.code === 'NotAuthorizedException' || err.code === 'UserNotFoundException') {
                        this.$dialog.alert('로그인 실패했습니다.')
                            .then(function(dialog) {
                                lg('Closed');
                            });
                    }
                    else {
                        this.errors = ['에러가 발생했습니다.'];
                    }
                }

//             .then(data => {
//                     lg('signin 2 data:', data);
//                     if(data.challengeName === "NEW_PASSWORD_REQUIRED") {
//                         comp.$dialog
//                             .prompt({
//                                 title: "Let's hear from you",
//                                 body: "What is the most important thing in life?",
//                                 promptHelp: 'Type in the box below and click "[+:okText]"'
//                             })
//                             .then(dialog => {
//                                 // Triggered when proceed button is clicked
//                                 // Show an alert with the user's input as the message
//                                 this.$dialog.alert(dialog.data || '[empty]');
//                                 Auth.completeNewPassword(user, )
//                             })
//                             .catch(() => {
//                                 // Triggered when dialog is dismissed by user
//
//                                 console.log('Prompt dismissed');
//                             });
// //                 comp.$modal.show({
// //                     title: '새 비밀번호가 필요합니다.',
// //                         template: `
// // <div style="padding-left:10px; padding-right: 10px;">
// // <v-text-field
// //                         placeholder=""
// //                         solo
// //                         v-model="newpassword"
// //                         label="새 비밀번호"
// //                         clearable
// //                         class="ma-0 hide-details"
// //                         />
// // </v-text-field>
// // {{text}}
// //                                 <button class="btn btn-sm btn-outline-secondary" id="btn-field-id-refresh" type="button" @click="newpassword_click()">refresh</button>
// // </div>
// //       `,
// //                         props: ['newpassword', 'text', 'foo']
// //                     }, {
// //                         text: 'This text is passed as a property',
// //                     }, {
// //                         name: 'apicmd_progress',
// //                         width: 500,
// //                         height: 'auto',
// //                     },
// //                 );
//                         return;
//                     }
//                     comp.$cookies.set('accountname', this.sign_name);
//                 })
//                     .catch(err => {
//                     });
            },
            async edit_submit() {
                lg('edit_submit 1 '+comp.$refs.edit_form.validate());
                if (comp.edit_dialog && comp.$refs.edit_form.validate()) {
                    let newPassword = comp.edit_item.NewPassword;
                    const loggedUser = await Auth.completeNewPassword(
                        comp.edit_user,              // the Cognito User Object
                        newPassword,       // the new password
                    );
                }
            }
        }
    }
</script>
